(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[998],{

/***/ 88226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/write",
      function () {
        return __webpack_require__(45103);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7642), __webpack_require__.e(3540)]).then(__webpack_require__.bind(__webpack_require__, 73540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73540)
            ];
        }
    }
});
var defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};
var CustomLottie = function(_param) {
    var width = _param.width, height = _param.height, style = _param.style, isStopped = _param.isStopped, _isClickToPauseDisabled = _param.isClickToPauseDisabled, isClickToPauseDisabled = _isClickToPauseDisabled === void 0 ? true : _isClickToPauseDisabled, eventListeners = _param.eventListeners, customOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "style",
        "isStopped",
        "isClickToPauseDisabled",
        "eventListeners"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lottie, {
        options: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, defaultOptions, customOptions),
        width: width,
        height: height,
        isStopped: isStopped !== null && isStopped !== void 0 ? isStopped : false,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            margin: 0
        }, style),
        isClickToPauseDisabled: isClickToPauseDisabled,
        eventListeners: eventListeners
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLottie);


/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 91809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 * @default
 * direction: DIRECTION.RIGHT,
 * color: theme.color.primary500,
 * size: 16,
 */ var ArrowCaret = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.RIGHT */ .JR.RIGHT : _direction, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.primary500 */ .Z.color.primary500 : _color, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowSVG, {
        direction: direction,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1782 7.635C11.3849 7.83656 11.3849 8.16336 11.1782 8.36492L6.23701 13.1821C6.03027 13.3837 5.69506 13.3837 5.48831 13.1821C5.28157 12.9806 5.28157 12.6538 5.48831 12.4522L10.0551 7.99996L5.48831 3.54771C5.28157 3.34615 5.28157 3.01936 5.48831 2.8178C5.69506 2.61624 6.03027 2.61624 6.23702 2.8178L11.1782 7.635Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowCaret);
var ArrowSVG = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-baea1f1c-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.TOP */ .JR.TOP ? -90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.BOTTOM */ .JR.BOTTOM ? 90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.LEFT */ .JR.LEFT ? 180 : 0;
});


/***/ }),

/***/ 99529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DeeplinkLoggerEventName; }
/* harmony export */ });
var DeeplinkLoggerEventName;
(function(DeeplinkLoggerEventName) {
    DeeplinkLoggerEventName["ClickCtaButton"] = "click_cta_button";
    DeeplinkLoggerEventName["ImpressionQrFloating"] = "impression_qr_floating";
    DeeplinkLoggerEventName["ClickCtaText"] = "click_cta_text";
})(DeeplinkLoggerEventName || (DeeplinkLoggerEventName = {}));


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 95392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53476);
/* harmony import */ var _hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50341);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4415);
/* harmony import */ var _recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3818);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10712);






var useSetAuthOnScreenFocus = function() {
    var focused = (0,_hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var setToken = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .tokenState */ .J1);
    var setUser = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__/* .userState */ .KL);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__/* .isWebView */ .vp)()) {
            if (!(window === null || window === void 0 ? void 0 : window.appToken) || (window === null || window === void 0 ? void 0 : window.appToken) === "undefined") {
                setToken("");
            } else {
                setToken(window.appToken);
            }
            if (!(window === null || window === void 0 ? void 0 : window.appUser) || (window === null || window === void 0 ? void 0 : window.appUser) === "undefined") {
                setUser(undefined);
            } else {
                setUser(JSON.parse(window.appUser));
            }
        }
    }, [
        focused,
        setToken,
        setUser
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useSetAuthOnScreenFocus);


/***/ }),

/***/ 13856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var _hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4365);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4415);





var useGetMyUncheckedAiAnswer = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .tokenState */ .J1);
    var ref = (0,_hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetMyUncheckedQuestionQuery */ .Eg)({}, {
        useErrorBoundary: false,
        refetchOnWindowFocus: true,
        retry: 0,
        enabled: !!token
    }), data = ref.data, refetch = ref.refetch;
    var unCheckedMyAiQuestion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            refetch()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function unCheckedMyAiQuestion() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(data === null || data === void 0 ? void 0 : data.myUncheckedQuestion)) {
        return null;
    }
    var _myUncheckedQuestion = data.myUncheckedQuestion, aiAnswerStatus = _myUncheckedQuestion.aiAnswerStatus, questionPid = _myUncheckedQuestion.questionPid, status = _myUncheckedQuestion.status;
    return {
        aiAnswerStatus: aiAnswerStatus,
        questionPid: questionPid,
        unCheckedMyAiQuestion: unCheckedMyAiQuestion,
        status: status
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetMyUncheckedAiAnswer);


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 17876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useNeverSeeAgain; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/hooks/useWindowFocus.tsx
var useWindowFocus = __webpack_require__(97167);
// EXTERNAL MODULE: ./node_modules/recoil-persist/dist/index.js
var dist = __webpack_require__(6983);
;// CONCATENATED MODULE: ./src/recoil/atoms/common/neverSeeAgain.ts


var persistAtom = (0,dist/* recoilPersist */.J)().persistAtom;
var neverSeeAgainState = (0,es.atom)({
    key: "neverSeeAgainState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});

// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/useNeverSeeAgain.tsx





var useNeverSeeAgain = function() {
    var focused = (0,useWindowFocus/* default */.Z)();
    var setNeverSeeAgain = (0,es.useSetRecoilState)(neverSeeAgainState);
    (0,react.useEffect)(function() {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            return;
        }
        if (!(window === null || window === void 0 ? void 0 : window.neverSeeAgainState) || (window === null || window === void 0 ? void 0 : window.neverSeeAgainState) === "undefined") {
            setNeverSeeAgain({});
        } else {
            setNeverSeeAgain(JSON.parse(window.neverSeeAgainState));
        }
    }, [
        focused,
        setNeverSeeAgain
    ]);
};
/* harmony default export */ var hooks_useNeverSeeAgain = (useNeverSeeAgain);


/***/ }),

/***/ 97167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
// ref: https://github.com/jpalumickas/use-window-focus

var hasFocus = function() {
    return typeof document !== "undefined" && document.hasFocus();
};
var useWindowFocus = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(hasFocus), focused = ref[0], setFocused = ref[1]; // Focus for first render
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setFocused(hasFocus()); // Focus for additional renders
        var onFocus = function() {
            return setFocused(true);
        };
        var onFocusOut = function() {
            return setFocused(false);
        };
        // AOS focusin / focusout
        window.addEventListener("focusin", onFocus);
        window.addEventListener("focusout", onFocusOut);
        // IOS focus / blur
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onFocusOut);
        return function() {
            window.removeEventListener("focusin", onFocus);
            window.removeEventListener("focusout", onFocusOut);
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onFocusOut);
        };
    }, []);
    return focused;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowFocus);


/***/ }),

/***/ 45103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ write; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
;// CONCATENATED MODULE: ./src/assets/lottie/bubble-ask.json
var bubble_ask_namespaceObject = JSON.parse('{"ddd":0,"fr":60,"h":40,"ip":0,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"","ln":"GruDTENQZECgBNCBWe5AF","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[0.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[6.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[12.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[18.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[23.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[28.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[33.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[38.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[42.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[46.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[50.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[54.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[58.23],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[61.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[64.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[67.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[70.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[73.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[75.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[78.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[80.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[82.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[84.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[86.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[87.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[89.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[90.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[91.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[92.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[93.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[94.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[95.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":80,"s":[96.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":81,"s":[97.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":82,"s":[97.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":83,"s":[98.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":84,"s":[98.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":85,"s":[98.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":86,"s":[99.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":87,"s":[99.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":88,"s":[99.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":89,"s":[99.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":90,"s":[99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":91,"s":[99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":92,"s":[99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":93,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":94,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":95,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[99.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[99.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[99.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[99.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[99.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[98.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[98.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[98.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[97.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[97.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[96.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[95.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[95.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[94.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[93.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[92.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[91.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[89.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[88.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[86.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":193,"s":[85.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":194,"s":[83.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":195,"s":[81.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":196,"s":[79.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":197,"s":[76.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":198,"s":[74.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":199,"s":[71.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":200,"s":[69.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":201,"s":[66.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":202,"s":[62.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":203,"s":[59.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":204,"s":[56.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":205,"s":[52.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":206,"s":[48.51],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":207,"s":[44.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":208,"s":[40.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":209,"s":[35.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":210,"s":[30.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":211,"s":[25.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":212,"s":[20.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":213,"s":[14.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":214,"s":[9.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":215,"s":[3.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[29,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[50,50],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[50,50],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[50.3,50.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[53.35,53.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[56.28,56.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[59.08,59.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[61.76,61.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[64.32,64.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[66.76,66.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[69.09,69.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[71.31,71.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[73.42,73.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[75.42,75.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[77.32,77.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[79.12,79.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[80.82,80.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[82.42,82.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[83.94,83.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[85.36,85.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[86.7,86.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[87.95,87.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[89.13,89.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[90.22,90.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[91.24,91.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[92.18,92.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[93.06,93.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[93.86,93.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[94.6,94.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[95.28,95.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[95.9,95.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[96.46,96.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[96.97,96.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[97.43,97.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[97.84,97.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":80,"s":[98.2,98.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":81,"s":[98.52,98.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":82,"s":[98.8,98.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":83,"s":[99.04,99.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":84,"s":[99.25,99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":85,"s":[99.43,99.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":86,"s":[99.57,99.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":87,"s":[99.69,99.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":88,"s":[99.78,99.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":89,"s":[99.86,99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":90,"s":[99.91,99.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":91,"s":[99.95,99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":92,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":93,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":94,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[99.89,99.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[99.82,99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[99.72,99.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[99.6,99.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[99.43,99.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[99.23,99.23],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[98.99,98.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[98.7,98.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[98.36,98.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[97.96,97.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[97.51,97.51],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[96.99,96.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[96.41,96.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[95.75,95.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[95.02,95.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[94.21,94.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[93.32,93.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[92.34,92.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[91.26,91.26],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[90.1,90.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":193,"s":[88.83,88.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":194,"s":[87.45,87.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":195,"s":[85.97,85.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":196,"s":[84.38,84.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":197,"s":[82.67,82.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":198,"s":[80.84,80.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":199,"s":[78.89,78.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":200,"s":[76.81,76.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":201,"s":[74.59,74.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":202,"s":[72.24,72.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":203,"s":[69.75,69.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":204,"s":[67.11,67.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":205,"s":[64.32,64.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":206,"s":[61.38,61.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":207,"s":[58.29,58.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":208,"s":[55.03,55.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":209,"s":[51.61,51.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":210,"s":[48.01,48.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":211,"s":[44.25,44.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":212,"s":[40.3,40.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":213,"s":[36.18,36.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":214,"s":[31.87,31.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":215,"s":[27.37,27.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":2,"ty":4,"nm":"","ln":"sVaXb7003aj6Tf6qVka9w","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[0.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[6.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[12.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[17.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[23.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[28.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[33.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[37.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[42.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[46.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[50.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[54.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[58.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[61.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[64.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[67.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[70.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[73.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[75.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[78.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[80.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[82.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[84.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[86.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[87.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[89.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[90.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[91.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[92.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[93.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[94.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[95.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[96.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[97.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[97.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[98.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[98.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[98.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[99.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[99.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[99.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[99.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[99.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[99.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[99.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[99.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[99.26],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[98.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[98.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[98.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[97.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[97.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[96.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[96.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[95.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[94.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[93.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[92.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[91.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[89.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[88.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[86.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[85.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[83.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[81.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[79.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[77.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[74.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[71.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[69.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[66.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[63.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[59.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[56.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[52.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[48.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[44.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[40.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[35.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[30.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[25.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[20.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[15.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[9.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[3.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[20,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[25.22,25.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[29.81,29.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[34.21,34.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[38.42,38.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[42.45,42.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[46.3,46.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[49.97,49.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[53.47,53.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[56.81,56.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[59.98,59.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[62.99,62.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[65.84,65.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[68.55,68.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[71.11,71.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[73.52,73.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[75.8,75.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[77.94,77.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[79.96,79.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[81.84,81.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[83.61,83.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[85.25,85.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[86.78,86.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[88.21,88.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[89.52,89.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[90.74,90.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[91.85,91.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[92.88,92.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[93.81,93.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[94.66,94.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[95.43,95.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[96.12,96.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[96.73,96.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[97.28,97.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[97.76,97.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[98.18,98.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[98.55,98.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[98.86,98.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[99.13,99.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[99.35,99.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[99.53,99.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[99.67,99.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[99.78,99.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[99.86,99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[99.92,99.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[99.96,99.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[99.98,99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[99.9,99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[99.83,99.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[99.73,99.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[99.6,99.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[99.44,99.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[99.24,99.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[99,99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[98.72,98.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[98.38,98.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[97.99,97.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[97.53,97.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[97.02,97.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[96.44,96.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[95.79,95.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[95.06,95.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[94.25,94.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[93.36,93.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[92.39,92.39],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[91.32,91.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[90.15,90.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[88.89,88.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[87.52,87.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[86.05,86.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[84.46,84.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[82.76,82.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[80.93,80.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[78.98,78.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[76.91,76.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[74.7,74.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[72.35,72.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[69.87,69.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[67.24,67.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[64.46,64.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[61.53,61.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[58.44,58.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[55.19,55.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[51.77,51.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[48.19,48.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[44.43,44.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[40.5,40.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[36.38,36.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[32.08,32.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[27.59,27.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":3,"ty":4,"nm":"","ln":"kcUvBLTPIq11yfReLkV8s","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":1,"s":[1.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":2,"s":[2.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":3,"s":[4.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":4,"s":[7.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":5,"s":[10.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":6,"s":[13.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":7,"s":[17.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":8,"s":[22.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":9,"s":[26.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":10,"s":[31.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":11,"s":[36.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":12,"s":[40.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":13,"s":[45.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":14,"s":[49.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":15,"s":[53.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":16,"s":[57.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":17,"s":[61.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":18,"s":[64.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":19,"s":[67.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":20,"s":[70.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":21,"s":[73.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":22,"s":[75.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[78.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[80.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[82.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[84.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[85.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[87.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[88.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[90.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[91.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[92.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[93.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[94.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[95.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[96.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[96.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[97.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[97.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[98.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[98.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[99.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[99.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[99.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[99.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[99.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[99.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[99.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[99.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[99.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":129,"s":[99.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":130,"s":[99.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":131,"s":[98.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":132,"s":[98.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":133,"s":[97.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":134,"s":[97.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":135,"s":[96.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":136,"s":[96.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":137,"s":[95.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":138,"s":[94.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":139,"s":[93.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":140,"s":[92.39],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":141,"s":[91.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":142,"s":[89.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":143,"s":[88.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":144,"s":[86.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[85.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[83.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[81.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[79.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[77.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[74.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[72.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[69.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[66.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[63.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[59.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[56.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[52.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[48.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[44.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[40.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[35.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[31.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[26.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[20.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[15.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[9.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[3.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[11,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":1,"s":[25.79,25.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":2,"s":[26.92,26.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":3,"s":[28.43,28.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":4,"s":[30.33,30.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":5,"s":[32.62,32.62],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":6,"s":[35.3,35.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":7,"s":[38.32,38.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":8,"s":[41.6,41.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":9,"s":[45.08,45.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":10,"s":[48.64,48.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":11,"s":[52.22,52.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":12,"s":[55.72,55.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":13,"s":[59.11,59.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":14,"s":[62.34,62.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":15,"s":[65.4,65.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":16,"s":[68.28,68.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":17,"s":[70.97,70.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":18,"s":[73.49,73.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":19,"s":[75.83,75.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":20,"s":[78,78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":21,"s":[80.03,80.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":22,"s":[81.9,81.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[83.64,83.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[85.25,85.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[86.75,86.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[88.13,88.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[89.4,89.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[90.58,90.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[91.66,91.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[92.66,92.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[93.58,93.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[94.41,94.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[95.18,95.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[95.87,95.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[96.5,96.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[97.07,97.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[97.58,97.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[98.04,98.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[98.44,98.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[98.79,98.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[99.09,99.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[99.34,99.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[99.55,99.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[99.72,99.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[99.85,99.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[99.98,99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[99.95,99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[99.9,99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[99.83,99.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[99.73,99.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[99.61,99.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":129,"s":[99.45,99.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":130,"s":[99.25,99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":131,"s":[99.02,99.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":132,"s":[98.73,98.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":133,"s":[98.4,98.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":134,"s":[98.01,98.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":135,"s":[97.56,97.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":136,"s":[97.05,97.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":137,"s":[96.47,96.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":138,"s":[95.82,95.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":139,"s":[95.1,95.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":140,"s":[94.29,94.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":141,"s":[93.41,93.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":142,"s":[92.43,92.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":143,"s":[91.37,91.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":144,"s":[90.21,90.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[88.95,88.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[87.59,87.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[86.12,86.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[84.54,84.54],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[82.84,82.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[81.02,81.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[79.08,79.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[77.01,77.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[74.81,74.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[72.47,72.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[69.99,69.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[67.37,67.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[64.6,64.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[61.67,61.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[58.59,58.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[55.35,55.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[51.94,51.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[48.37,48.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[44.62,44.62],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[40.69,40.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[36.58,36.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[32.29,32.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[27.8,27.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":4,"ty":4,"ln":"layer_4","sr":1,"ks":{"a":{"a":0,"k":[15,15]},"o":{"a":0,"k":100},"p":{"a":0,"k":[20,20]},"r":{"a":0,"k":0},"s":{"a":0,"k":[133.33,133.33]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface6","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[2.24,0],[2.31,-1.39],[1.27,-2.37],[-0.13,-2.7],[-1.3,-2.14],[0,0],[-0.25,-0.3],[-0.38,0.07],[0,0],[-2.12,-0.01],[-2.02,0.96],[-1.4,1.75],[-0.5,2.19],[0.5,2.19],[1.39,1.75],[2.02,0.97]],"o":[[-2.02,-0.98],[-2.7,0],[-2.31,1.38],[-1.27,2.37],[0.12,2.5],[0,0],[-0.14,0.36],[0.25,0.3],[0,0],[1.93,0.89],[2.24,0.01],[2.02,-0.96],[1.41,-1.75],[0.5,-2.18],[-0.49,-2.19],[-1.4,-1.76],[0,0]],"v":[[21.47,1.58],[15,0.1],[7.34,2.22],[1.87,7.96],[0.12,15.71],[2.29,22.79],[0.16,28.45],[0.34,29.52],[1.36,29.88],[8.79,28.54],[14.93,29.9],[21.41,28.45],[26.62,24.33],[29.52,18.35],[29.54,11.71],[26.66,5.72],[21.47,1.58]]}}},{"ty":"fl","c":{"a":0,"k":[0.12,0.65,0.46,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}],"meta":{"g":"https://jitter.video"},"nm":"무물보-질문하기","op":216,"v":"5.7.4","w":40}');
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/CustomLottieIcon.tsx
var CustomLottieIcon = __webpack_require__(84655);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/common/communication/qna/CategoryBottomSheet.tsx
var CategoryBottomSheet = __webpack_require__(80138);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
;// CONCATENATED MODULE: ./src/components/molecules/qna-agreement-info-box/index.tsx

var QnaAgreementInfoBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col gap-[12px] bg-gray-30 p-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "typography-ui-15sb w-full text-gray-700",
                children: "실시간 의료 상담은 이렇게 운영돼요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex w-full list-disc flex-col gap-[8px] pl-[16px] marker:text-gray-400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: "폭력적\xb7공격적인 내용, 서비스 목적과 맞지 않는 질문, 동일 내용의 반복(3회 이상) 등은 사전 예고 없이 삭제될 수 있습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: "서비스 운영을 방해하는 행위가 반복될 경우, 회원과 의료진 보호를 위해 서비스 이용이 사전 안내 없이 한시적 또는 영구적으로 제한될 수 있습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: "실시간 의료 상담에서 등록된 질문과 답변은 모두에게 공개되며, 서비스 홍보 목적으로 활용될 수 있습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: [
                            "답변은 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13sb",
                                children: "참고용"
                            }),
                            "으로서 의학적 판단이나 진료 행위를",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-13sb",
                                children: "대체할 수 없으며,"
                            }),
                            " 모든 약물 상호작용을 포함하지 않을 수 있습니다. 이에 대해 닥터나우와 답변 의료인은 어떠한 책임도 지지 않습니다."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: "정확한 진단을 위해서는 닥터나우 앱에서 비대면 진료를 신청하거나, 가까운 병원에 내원해 주세요."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "typography-ui-13r pl-[4px] text-gray-500",
                        children: "실시간 의료 상담에 등록한 질문은 고객센터를 통한 삭제 요청이 없는 한 계속 남게 됩니다."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var qna_agreement_info_box = (QnaAgreementInfoBox);

// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/icon/AgreementCheck.tsx


var AgreementCheck = function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.gray100 */.Z.color.gray100 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_2549_19679",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_2549_19679)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.95838 12.2245L14.8089 5.37394C15.0305 5.15232 15.2932 5.0415 15.597 5.0415C15.9007 5.0415 16.1634 5.15232 16.385 5.37394C16.6066 5.59557 16.7174 5.85825 16.7174 6.162C16.7174 6.46574 16.6066 6.72842 16.385 6.95005L8.7419 14.5932C8.52027 14.8148 8.2591 14.9256 7.95838 14.9256C7.65766 14.9256 7.39648 14.8148 7.17486 14.5932L3.61507 11.0334C3.39345 10.8118 3.28416 10.5491 3.28717 10.2453C3.29018 9.94159 3.4025 9.6789 3.62413 9.45727C3.84575 9.23565 4.10844 9.12484 4.41219 9.12484C4.71593 9.12484 4.97861 9.23565 5.20023 9.45727L7.95838 12.2245Z",
                    fill: color
                })
            })
        ]
    });
};
/* harmony default export */ var icon_AgreementCheck = (AgreementCheck);

;// CONCATENATED MODULE: ./src/components/atom/icon/KeyboardArrowRight.tsx

var KeyboardArrowRight = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5001 13.2292L10.7334 9.99583L7.5001 6.7625C7.1751 6.4375 7.1751 5.9125 7.5001 5.5875C7.8251 5.2625 8.3501 5.2625 8.6751 5.5875L12.5001 9.4125C12.8251 9.7375 12.8251 10.2625 12.5001 10.5875L8.6751 14.4125C8.3501 14.7375 7.8251 14.7375 7.5001 14.4125C7.18343 14.0875 7.1751 13.5542 7.5001 13.2292Z",
            fill: "#DFE1E2"
        })
    });
};
/* harmony default export */ var icon_KeyboardArrowRight = (KeyboardArrowRight);

// EXTERNAL MODULE: ./src/components/molecules/bottom-sheet/index.tsx + 5 modules
var bottom_sheet = __webpack_require__(5679);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-write-mobile-template/PolicyAgreementBottomSheet.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  padding: 12px 24px 24px 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  align-self: stretch;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0px 10px 16px 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 8px 0px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1 0 0;\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var PolicyAgreementBottomSheet = function(param) {
    var _viewModel = param.viewModel, isBottomSheetOpened = _viewModel.isBottomSheetOpened, checkAll = _viewModel.checkAll, isAllChecked = _viewModel.isAllChecked, policyList = _viewModel.policyList, checkPolicy = _viewModel.checkPolicy, isAllRequiredChecked = _viewModel.isAllRequiredChecked, isPolicyChecked = _viewModel.isPolicyChecked, closeBottomSheet = _viewModel.closeBottomSheet, agreeToPolicies = _viewModel.agreeToPolicies, openPolicyDetail = _viewModel.openPolicyDetail, afterSubmit = param.afterSubmit, isSubmitButtonDisabled = param.isSubmitButtonDisabled;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            agreeToPolicies()
                        ];
                    case 1:
                        _state.sent();
                        afterSubmit === null || afterSubmit === void 0 ? void 0 : afterSubmit();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_sheet/* default */.ZP, {
        index: 10,
        isOpened: isBottomSheetOpened(),
        onClickOverlay: closeBottomSheet,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleAndDescription, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "상담을 위해 동의가 필요해요."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: "의료 상담 특성 상, 아래의 약관 동의가 필요해요.\n동의해주신만큼 도움되는 정보를 제공해드릴게요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyAgreementForm, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreeToAllButton, {
                            onClick: checkAll,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementCheckButton, {
                                    checked: isAllChecked()
                                }),
                                "전체 동의"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyList, {
                            children: policyList.map(function(policy) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyRow, {
                                    onClick: function() {
                                        return checkPolicy(policy);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckAndPolicyText, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementCheckButton, {
                                                    checked: isPolicyChecked(policy)
                                                }),
                                                "[".concat(policy.required ? "필수" : "선택", "] ").concat(policy.title)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return openPolicyDetail(policy);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_KeyboardArrowRight, {})
                                        })
                                    ]
                                }, "policy-".concat(policy.title));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    size: "xl",
                    className: "w-full",
                    onClick: onSubmit,
                    disabled: !isAllRequiredChecked() || isSubmitButtonDisabled,
                    children: "확인"
                })
            ]
        })
    });
};
/* harmony default export */ var qna_write_mobile_template_PolicyAgreementBottomSheet = (PolicyAgreementBottomSheet);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-0"
})(_templateObject());
var TitleAndDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var PolicyAgreementForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-4"
})(_templateObject4());
var AgreeToAllButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    border-radius: 8px;\n    border: 1px solid ".concat(theme.color.gray100, ";\n    \n    ").concat(theme.typography.UI16M, ";\n    color: ").concat(theme.color.gray600, ";   \n  ");
});
var PolicyList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-6"
})(_templateObject6());
var PolicyRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-7"
})(_templateObject7());
var CheckAndPolicyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-afa051b4-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16R, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var AgreementCheckButton = (0,styled_components_browser_esm/* default */.ZP)(icon_AgreementCheck).attrs(function(param) {
    var checked = param.checked, theme = param.theme;
    return {
        color: checked ? theme.color.primary600 : theme.color.gray100
    };
}).withConfig({
    componentId: "sc-afa051b4-9"
})(_templateObject9());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/components/atom/form/InputLabel.tsx
var InputLabel = __webpack_require__(28541);
// EXTERNAL MODULE: ./src/components/atom/icon/arrow/ArrowCaret.tsx
var ArrowCaret = __webpack_require__(91809);
;// CONCATENATED MODULE: ./src/components/molecules/dropdown/index.tsx

function dropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n\n  ",
        ";\n"
    ]);
    dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 18px 42px 18px 16px;\n  border: none;\n  background-color: transparent;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  ",
        ";\n"
    ]);
    dropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dropdown_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n"
    ]);
    dropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Dropdown = function(param) {
    var id = param.id, label = param.label, labelSpacing = param.labelSpacing, className = param.className, placeholder = param.placeholder, isOpened = param.isOpened, onClickTrigger = param.onClickTrigger, _placeHolderColor = param.placeHolderColor, placeHolderColor = _placeHolderColor === void 0 ? "black" : _placeHolderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.ZP, {
                htmlFor: id,
                label: label,
                labelSpacing: labelSpacing,
                onClick: onClickTrigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownTrigger, {
                    type: "button",
                    onClick: onClickTrigger,
                    placeHolderColor: placeHolderColor,
                    children: [
                        placeholder,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownButtonChevron, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowCaret/* default */.Z, {
                                color: placeHolderColor,
                                direction: isOpened ? common/* DIRECTION.TOP */.JR.TOP : common/* DIRECTION.BOTTOM */.JR.BOTTOM
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var dropdown = (Dropdown);
var DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f376ae3a-0"
})(dropdown_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n    background: ").concat(theme.color.gray20, ";\n  ");
});
var DropdownTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f376ae3a-1"
})(dropdown_templateObject1(), function(param) {
    var theme = param.theme, placeHolderColor = param.placeHolderColor;
    return "\n    ".concat(theme.typography.UI16M, ";\n    color: ").concat(placeHolderColor, ";\n    ");
});
var DropdownButtonChevron = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f376ae3a-2"
})(dropdown_templateObject2());

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-write-mobile-template/QnaWriteCategory.tsx


function QnaWriteCategory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    QnaWriteCategory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 24px;\n  gap: 8px;\n"
    ]);
    QnaWriteCategory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 12px;\n  border-radius: 40px;\n  cursor: pointer;\n\n  ",
        ";\n"
    ]);
    QnaWriteCategory_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var QnaWriteCategory = function(param) {
    var selectedTags = param.selectedTags, onChangeSelectedTags = param.onChangeSelectedTags, selectedCategoriesBottomSheetTabItem = param.selectedCategoriesBottomSheetTabItem, showCategoriesBottomSheet = param.showCategoriesBottomSheet, toggleCategoriesBottomSheet = param.toggleCategoriesBottomSheet;
    var onSelectTagItem = function(tag) {
        var tagIndex = selectedTags.findIndex(function(name) {
            return name === tag.name;
        });
        var list = (0,_to_consumable_array/* default */.Z)(selectedTags);
        if (tagIndex < 0) {
            list.push(tag.name);
        } else {
            list.splice(tagIndex, 1);
        }
        onChangeSelectedTags(list);
    };
    var isSelectedTag = function(tag) {
        return selectedTags.includes(tag.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerCategoryWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown, {
                id: "quickAnswerCategory",
                label: "카테고리",
                labelSpacing: "12px",
                placeholder: (selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.title) || "증상•과목 선택",
                placeHolderColor: theme/* default.color.gray600 */.Z.color.gray600,
                isOpened: showCategoriesBottomSheet,
                onClickTrigger: function() {
                    return toggleCategoriesBottomSheet(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAnswerTagsWrapper, {
                children: selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.tags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        selected: isSelectedTag(tag),
                        onClick: function() {
                            return onSelectTagItem(tag);
                        },
                        children: tag.name
                    }, tag.name);
                })
            })
        ]
    });
};
/* harmony default export */ var qna_write_mobile_template_QnaWriteCategory = (QnaWriteCategory);
var QuickAnswerCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40875f81-0"
})(QnaWriteCategory_templateObject());
var QuickAnswerTagsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-40875f81-1"
})(QnaWriteCategory_templateObject1());
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-40875f81-2"
})(QnaWriteCategory_templateObject2(), function(param) {
    var theme = param.theme, selected = param.selected;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(selected ? "#f76707" : theme.color.gray600, ";\n    background: ").concat(theme.color.white, ";\n    border: 1px solid ").concat(selected ? "#fd7e14" : theme.color.gray200, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/form/TextareaMobile.tsx
var TextareaMobile = __webpack_require__(55484);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-write-mobile-template/QnaWriteContentTextarea.tsx

function QnaWriteContentTextarea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n"
    ]);
    QnaWriteContentTextarea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteContentTextarea_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n"
    ]);
    QnaWriteContentTextarea_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var QnaWriteContentTextarea = function(param) {
    var question = param.question, onChangeQuestion = param.onChangeQuestion, placeholder = param.placeholder;
    var onChangeTextarea = function(event) {
        onChangeQuestion(event.target.value.replace(/^\s+/g, ""));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaContentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteTextarea, {
            id: "quickAnswerQuestion",
            label: "질문",
            height: "150px",
            placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "예) 약을 처방 받았는데 술을 마셔도 될까요?",
            maxLength: 500,
            value: question,
            onChange: onChangeTextarea,
            showCharacterCount: true
        })
    });
};
/* harmony default export */ var qna_write_mobile_template_QnaWriteContentTextarea = (QnaWriteContentTextarea);
var QnaContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d492d1a0-0"
})(QnaWriteContentTextarea_templateObject());
var QnaWriteTextarea = (0,styled_components_browser_esm/* default */.ZP)(TextareaMobile/* default */.Z).withConfig({
    componentId: "sc-d492d1a0-1"
})(QnaWriteContentTextarea_templateObject1());

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-write-mobile-template/QnaWriteVerified.tsx

function QnaWriteVerified_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 0;\n"
    ]);
    QnaWriteVerified_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteVerified_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    QnaWriteVerified_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaWriteVerified_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n\n  ",
        ";\n  \n"
    ]);
    QnaWriteVerified_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QnaWriteVerified_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"
    ]);
    QnaWriteVerified_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QnaWriteVerified_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-left: 4px;\n  padding-left: 12px;\n  margin-bottom: 4px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 7px;\n    width: 3.5px;\n    height: 3.5px;\n    border-radius: 50%;\n    background-color: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    QnaWriteVerified_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var QnaWriteVerified = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAnswerWriteImagesFieldWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionImageInformation, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageInformationTitle, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "verified_user",
                            size: 16,
                            color: theme/* default.color.blue700 */.Z.color.blue700,
                            filled: true
                        }),
                        "안심하세요!"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInformationList, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInformationListItem, {
                        children: "개인정보 보호를 위해 질문에 개인정보를 입력하지 않도록 주의해 주세요."
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var qna_write_mobile_template_QnaWriteVerified = (QnaWriteVerified);
var QuickAnswerWriteImagesFieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-229a3e6d-0"
})(QnaWriteVerified_templateObject());
var QuestionImageInformation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-229a3e6d-1"
})(QnaWriteVerified_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.blue100;
});
var ImageInformationTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-229a3e6d-2"
})(QnaWriteVerified_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.blue500, ";\n  ");
});
var ImageInformationList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-229a3e6d-3"
})(QnaWriteVerified_templateObject3());
var ImageInformationListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-229a3e6d-4"
})(QnaWriteVerified_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13R, ";\n    color: ").concat(theme.color.gray500, ";\n    line-height: 18px;\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/qna/qna-write-mobile-template/index.tsx



function qna_write_mobile_template_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n"
    ]);
    qna_write_mobile_template_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function qna_write_mobile_template_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 40px;\n  width: 100%;\n"
    ]);
    qna_write_mobile_template_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function qna_write_mobile_template_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    color: ",
        ";\n    white-space: pre-wrap;\n    "
    ]);
    qna_write_mobile_template_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function qna_write_mobile_template_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px 0 4px;\n\n  ",
        ";\n"
    ]);
    qna_write_mobile_template_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function qna_write_mobile_template_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px;\n"
    ]);
    qna_write_mobile_template_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function qna_write_mobile_template_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    qna_write_mobile_template_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var QnaWriteMobileTemplate = function(_param) {
    var client = _param.client, _qnaWriteMobileViewModel = _param.qnaWriteMobileViewModel, _qnaWriteMobileViewModel = _qnaWriteMobileViewModel !== null ? _qnaWriteMobileViewModel : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined")), viewModel = (0,_extends/* default */.Z)({}, _param.qnaWriteMobileViewModel);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: "".concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                            type: "qna"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerWriteTemplateContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                        width: 40,
                                        height: 40,
                                        animationData: bubble_ask_namespaceObject
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopTitle, {
                                        children: "건강 정보 AI 닥터나우에게\n건강 고민을 물어보세요"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerWriteFormWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_write_mobile_template_QnaWriteContentTextarea, {
                                        question: viewModel.question,
                                        onChangeQuestion: viewModel.setQuestion,
                                        placeholder: (ref = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref === void 0 ? void 0 : ref.contentPlaceholder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_write_mobile_template_QnaWriteCategory, {
                                        selectedTags: viewModel.selectedTags,
                                        onChangeSelectedTags: viewModel.setSelectedTags,
                                        selectedCategoriesBottomSheetTabItem: viewModel.selectedCategoriesBottomSheetTabItem,
                                        showCategoriesBottomSheet: viewModel.showCategoriesBottomSheet,
                                        toggleCategoriesBottomSheet: viewModel.toggleCategoriesBottomSheet
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_write_mobile_template_QnaWriteVerified, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAnswerWriteInfoBoxWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_agreement_info_box, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    size: "xl",
                                    className: "w-full",
                                    disabled: viewModel.isSubmitButtonDisabled,
                                    type: "submit",
                                    onClick: viewModel.checkEnableSubmit,
                                    children: "물어보기"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBottomSheet/* default */.Z, {
                                isVisible: viewModel.showCategoriesBottomSheet,
                                toggleBottomSheet: viewModel.toggleCategoriesBottomSheet,
                                onClickCategoryItem: viewModel.onClickCategoriesBottomSheetTabListItem,
                                categoryGroup: viewModel.categoryGroup,
                                selectedTab: viewModel.selectedTab,
                                onClickCategoriesBottomSheetTab: viewModel.onClickCategoriesBottomSheetTab,
                                getSelectedTabItemList: viewModel.getSelectedTabItemList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_write_mobile_template_PolicyAgreementBottomSheet, {
                                isSubmitButtonDisabled: viewModel.isSubmitButtonDisabled,
                                viewModel: viewModel.policyAgreementBottomSheetViewModel,
                                afterSubmit: viewModel.requestAiAnswer
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var qna_write_mobile_template = (QnaWriteMobileTemplate);
var QuickAnswerWriteTemplateContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-ddb64591-0"
})(qna_write_mobile_template_templateObject());
var TopTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb64591-1"
})(qna_write_mobile_template_templateObject1());
var TopTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb64591-2"
})(qna_write_mobile_template_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(qna_write_mobile_template_templateObject2(), theme.typography.UI22SB, theme.color.gray700);
});
var QuickAnswerWriteFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb64591-3"
})(qna_write_mobile_template_templateObject4());
var QuickAnswerWriteInfoBoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb64591-4"
})(qna_write_mobile_template_templateObject5());

// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/hooks/community/mobile/community.gql.impl.tsx
var community_gql_impl = __webpack_require__(42549);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/hooks/community/useGetCommunityUser.ts






var parseCommunityUser = function(data) {
    var _bannedUntil;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        nickname: data.communityUser.nickname,
        userId: data.communityUser.userId,
        tutorialCompleted: data.communityUser.tutorialCompleted,
        profileImageUrl: data.communityUser.profileImageUrl,
        isAdmin: data.communityUser.isAdmin,
        bannedUntil: (_bannedUntil = data.communityUser.bannedUntil) !== null && _bannedUntil !== void 0 ? _bannedUntil : undefined,
        formattedBannedDate: data.communityUser.bannedUntil ? dayjs_min_default()(data.communityUser.bannedUntil).format("YYYY년 MM월 DD일 HH시까지") : undefined,
        isBanned: dayjs_min_default()().isBefore(data.communityUser.bannedUntil)
    });
};
var useGetCommunityUser = function() {
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var ref = (0,community_gql_impl/* useGetCommunityUserQuery */.K_)({}, {
        enabled: !!token,
        select: function(data) {
            return parseCommunityUser(data);
        },
        refetchOnWindowFocus: true
    }), userProfileData = ref.data, communityUserRefetch = ref.refetch, isUserDataLoading = ref.isLoading;
    return {
        userProfileData: userProfileData,
        isUserDataLoading: isUserDataLoading,
        communityUserRefetch: communityUserRefetch
    };
};
/* harmony default export */ var community_useGetCommunityUser = (useGetCommunityUser);

// EXTERNAL MODULE: ./src/hooks/qna/mobile/qna.gql.impl.tsx
var qna_gql_impl = __webpack_require__(4365);
;// CONCATENATED MODULE: ./src/hooks/qna/mobile/write/useSetApproveAgreements.ts

var useSetApproveAgreements = function() {
    var ref = (0,qna_gql_impl/* useSetApproveAgreementsMutation */.LN)(), setApproveAgreementMutate = ref.mutateAsync;
    return {
        setApproveAgreementMutate: setApproveAgreementMutate
    };
};
/* harmony default export */ var write_useSetApproveAgreements = (useSetApproveAgreements);

// EXTERNAL MODULE: ./src/hooks/qna/qna.gql.impl.tsx
var qna_qna_gql_impl = __webpack_require__(71743);
;// CONCATENATED MODULE: ./src/hooks/qna/useAgreementsForAskQuestionCategory.tsx

var parseAgreements = function(agreements) {
    return agreements.getAgreementsByCategory;
};
var useAgreementsForAskQuestionCategory = function() {
    var data = (0,qna_qna_gql_impl/* useGetAgreementsForQuestionCategoryQuery */.hC)({}, {
        select: parseAgreements
    }).data;
    return {
        data: data !== null && data !== void 0 ? data : []
    };
};
/* harmony default export */ var qna_useAgreementsForAskQuestionCategory = (useAgreementsForAskQuestionCategory);

;// CONCATENATED MODULE: ./src/hooks/qna/useGetCheckApprovedByCategory.tsx

var useGetCheckApprovedByCategory = function(param) {
    var category = param.category;
    var data = (0,qna_qna_gql_impl/* useGetCheckApprovedByCategoryQuery */.EU)({
        category: category
    }, {
        select: function(response) {
            return response.checkApproved;
        }
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var qna_useGetCheckApprovedByCategory = (useGetCheckApprovedByCategory);

;// CONCATENATED MODULE: ./src/hooks/qna/useGetCheckApprovedByType.tsx

var useGetCheckApprovedByType = function(param) {
    var category = param.category, type = param.type;
    var data = (0,qna_qna_gql_impl/* useGetCheckApprovedByTypeQuery */.Sd)({
        request: {
            agreementCategory: category,
            agreementType: type
        }
    }, {
        select: function(response) {
            return response.checkApprovedByType;
        }
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var qna_useGetCheckApprovedByType = (useGetCheckApprovedByType);

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/qna/mobile/write/usePolicyAgreementBottomSheetViewModel.tsx










var usePolicyAgreementBottomSheetViewModel = function() {
    var ref = qna_useAgreementsForAskQuestionCategory(), _policyList = ref.data;
    var ref1 = qna_useGetCheckApprovedByCategory({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement
    }), hasAlreadyAgreedToAll = ref1.data;
    var ref2 = qna_useGetCheckApprovedByType({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement,
        type: gql_schema/* AgreementType.CollectHealthInformation */.qEJ.CollectHealthInformation
    }), hasAgreedToHealthInformation = ref2.data;
    var ref3 = qna_useGetCheckApprovedByType({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement,
        type: gql_schema/* AgreementType.LocationBasedServiceTermsAndConditions */.qEJ.LocationBasedServiceTermsAndConditions
    }), hasAgreedToLocation = ref3.data;
    var setApproveAgreementMutate = write_useSetApproveAgreements().setApproveAgreementMutate;
    var ref4 = (0,react.useState)([]), checkedPolicyIdList = ref4[0], setCheckedPolicyIdList = ref4[1];
    var ref5 = (0,react.useState)(false), isPolicyAgreementBottomSheetOpened = ref5[0], setIsPolicyAgreementBottomSheetOpened = ref5[1];
    var policyList = (0,react.useMemo)(function() {
        return _policyList.filter(function(policy) {
            return !(policy.type === gql_schema/* AgreementType.LocationBasedServiceTermsAndConditions */.qEJ.LocationBasedServiceTermsAndConditions && (hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result));
        });
    }, [
        _policyList
    ]);
    var openPolicyAgreementBottomSheet = function() {
        setIsPolicyAgreementBottomSheetOpened(true);
    };
    var closePolicyAgreementBottomSheet = function() {
        setIsPolicyAgreementBottomSheetOpened(false);
    };
    var checkedPolicyList = (0,react.useMemo)(function() {
        return policyList.filter(function(policy) {
            return checkedPolicyIdList.includes(policy.id);
        });
    }, [
        checkedPolicyIdList,
        policyList
    ]);
    var checkAll = function() {
        if (checkedPolicyIdList.length === policyList.length) {
            setCheckedPolicyIdList([]);
        } else {
            setCheckedPolicyIdList(policyList.map(function(policy) {
                return policy.id;
            }));
        }
    };
    var checkPolicy = function(policy) {
        if (checkedPolicyIdList.includes(policy.id)) {
            setCheckedPolicyIdList(function(_prev) {
                return _prev.filter(function(id) {
                    return id !== policy.id;
                });
            });
        } else {
            setCheckedPolicyIdList(function(_prev) {
                return (0,_to_consumable_array/* default */.Z)(_prev).concat([
                    policy.id
                ]);
            });
        }
    };
    var isAllChecked = function() {
        if (policyList.length === 0) {
            return false;
        }
        return Boolean(checkedPolicyIdList.length === policyList.length);
    };
    var isAllRequiredChecked = function() {
        if (policyList.length === 0) {
            return false;
        }
        var requiredList = policyList.filter(function(policy) {
            return policy.required;
        });
        return requiredList.length === 0 || requiredList.every(function(policy) {
            return checkedPolicyIdList.includes(policy.id);
        });
    };
    var isPolicyChecked = function(policy) {
        return checkedPolicyIdList.includes(policy.id);
    };
    var agreeToPolicies = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setApproveAgreementMutate({
                                request: {
                                    approvedAgreementIds: checkedPolicyIdList,
                                    disapprovedAgreementIds: []
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function agreeToPolicies() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasAgreedToMinimum = Boolean((hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result) && (hasAgreedToHealthInformation === null || hasAgreedToHealthInformation === void 0 ? void 0 : hasAgreedToHealthInformation.result));
    var openPolicyDetail = function(policy) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                url: policy.url
            });
        }
        window.open(policy.url, "_blank");
    };
    return {
        policyList: policyList,
        checkedPolicyList: checkedPolicyList,
        checkPolicy: checkPolicy,
        checkAll: checkAll,
        isAllChecked: isAllChecked,
        isAllRequiredChecked: isAllRequiredChecked,
        isPolicyChecked: isPolicyChecked,
        hasAlreadyAgreedToAll: function() {
            return Boolean(hasAlreadyAgreedToAll);
        },
        hasAgreedToMinimum: function() {
            return hasAgreedToMinimum;
        },
        hasAgreedToLocation: function() {
            return Boolean(hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result);
        },
        agreeToPolicies: agreeToPolicies,
        isBottomSheetOpened: function() {
            return Boolean(isPolicyAgreementBottomSheetOpened);
        },
        openBottomSheet: openPolicyAgreementBottomSheet,
        closeBottomSheet: closePolicyAgreementBottomSheet,
        openPolicyDetail: openPolicyDetail
    };
};
/* harmony default export */ var write_usePolicyAgreementBottomSheetViewModel = (usePolicyAgreementBottomSheetViewModel);

// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/useNeverSeeAgain.tsx + 1 modules
var useNeverSeeAgain = __webpack_require__(17876);
// EXTERNAL MODULE: ./src/recoil/atoms/common/user.ts
var common_user = __webpack_require__(3818);
// EXTERNAL MODULE: ./src/recoil/atoms/qna/index.ts
var qna = __webpack_require__(96469);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/types/qna.ts
var types_qna = __webpack_require__(18457);
// EXTERNAL MODULE: ./src/utils/error.ts
var utils_error = __webpack_require__(88295);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/home/useGetMyUncheckedAiAnswer.ts
var useGetMyUncheckedAiAnswer = __webpack_require__(13856);
;// CONCATENATED MODULE: ./src/hooks/qna/mobile/write/useQnaWriteBottomSheetGroup.ts

var useQnaWriteBottomSheetGroup = function() {
    var ref = (0,react.useState)(), activeBottomSheetType = ref[0], setActiveBottomSheetType = ref[1];
    var ref1 = (0,react.useState)(false), isCheckedAgreement = ref1[0], setIsCheckedAgreement = ref1[1];
    var onChangeBottomSheetType = function(type) {
        if (!type) {
            return setActiveBottomSheetType(undefined);
        }
        setActiveBottomSheetType(type);
    };
    var onChangeAgreement = function() {
        setIsCheckedAgreement(function(prev) {
            return !prev;
        });
    };
    return {
        isApprovedByLocationCategory: true,
        activeBottomSheetType: activeBottomSheetType,
        onChangeBottomSheetType: onChangeBottomSheetType,
        isCheckedAgreement: isCheckedAgreement,
        onChangeAgreement: onChangeAgreement,
        isAiAgreementNeeded: true
    };
};
/* harmony default export */ var write_useQnaWriteBottomSheetGroup = (useQnaWriteBottomSheetGroup);

// EXTERNAL MODULE: ./src/hooks/qna/useGetQnaCategoryGroup.ts
var useGetQnaCategoryGroup = __webpack_require__(62139);
;// CONCATENATED MODULE: ./src/hooks/qna/useQnaWriteMobileViewModel.ts




























var useQnaWriteMobileViewModel = function() {
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    (0,useNeverSeeAgain/* default */.Z)();
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var setRealTimeAnswerState = (0,es.useSetRecoilState)(qna/* realTimeAnswerState */.N);
    var qnaWriteBottomSheetGroup = write_useQnaWriteBottomSheetGroup();
    var unCheckedAiAnswer = (0,useGetMyUncheckedAiAnswer/* default */.Z)();
    var policyAgreementBottomSheetViewModel = write_usePolicyAgreementBottomSheetViewModel();
    var ref2 = (0,react.useState)(""), question = ref2[0], setQuestion = ref2[1];
    var ref3 = (0,react.useState)(false), isSubmitLoading = ref3[0], setIsSubmitLoading = ref3[1];
    var ref4 = (0,react.useState)(false), pregnant = ref4[0], setPregnant = ref4[1];
    var ref5 = (0,react.useState)([]), selectedTags = ref5[0], setSelectedTags = ref5[1];
    var ref6 = (0,react.useState)(false), showCategoriesBottomSheet = ref6[0], setShowCategoriesBottomSheet = ref6[1];
    var userProfileData = community_useGetCommunityUser().userProfileData;
    var user = (0,es.useRecoilValue)(common_user/* userState */.KL);
    var ref7 = (0,react.useState)(types_qna/* QnaCategoryType.TREATMENT */.Q0.TREATMENT), selectedTab = ref7[0], setSelectedTab = ref7[1];
    var categoryGroup = (0,useGetQnaCategoryGroup/* default */.Z)().categoryGroup;
    // 질문 작성
    var ref8 = (0,qna_gql_impl/* useAddQuestionWithAiAnswerMutation */.u1)(), addQuestionWithAiAnswerMutate = ref8.mutate;
    var ref9 = (0,react.useState)(), selectedCategoriesBottomSheetTabItem = ref9[0], setSelectedCategoriesBottomSheetTabItem = ref9[1];
    var isSubmitButtonDisabled = (0,react.useMemo)(function() {
        var ref;
        return isSubmitLoading || ((ref = userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.isBanned) !== null && ref !== void 0 ? ref : false);
    }, [
        isSubmitLoading,
        userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.isBanned
    ]);
    var onSubmitSuccess = function(response) {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            setRealTimeAnswerState(true);
        }
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "quick_answer_write_submit_click",
                pageName: pageName
            }
        });
        var _addQuestionV2 = response.addQuestionV2, aiAnswerAvailable = _addQuestionV2.aiAnswerAvailable, questionPid = _addQuestionV2.questionPid;
        if (aiAnswerAvailable) {
            moveToPage({
                webLink: "".concat(common/* ROUTES.QNA.AI.path */.Z6.QNA.AI.path, "/").concat(questionPid),
                mobileScreenName: common/* ROUTES.QNA.AI.appScreenName */.Z6.QNA.AI.appScreenName,
                params: {
                    questionPid: questionPid
                },
                type: RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE
            });
            return;
        }
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.AITITLE.path */.Z6.QNA.AITITLE.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.AITITLE.appScreenName */.Z6.QNA.AITITLE.appScreenName,
            params: {
                questionPid: questionPid
            },
            type: RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE
        });
    };
    var onSubmitError = function(error) {
        return toast({
            text: (0,utils_error/* getBffErrorMessage */.p)(error),
            direction: "bottom"
        });
    };
    var onClickCheckPregnant = function() {
        setPregnant(function(prev) {
            return !prev;
        });
    };
    // 카테고리 Bottom Sheet Show/Hide Toggle
    var toggleCategoriesBottomSheet = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setShowCategoriesBottomSheet(value);
    };
    // 카테고리 Bottom Sheet Tab Click
    var onClickCategoriesBottomSheetTab = function(tab) {
        setSelectedTab(tab.value);
    };
    var getSelectedTabItemList = function() {
        if (!categoryGroup) return [];
        return categoryGroup.tabsList.filter(function(tab) {
            return tab.key === selectedTab;
        })[0].categories;
    };
    // Bottom Sheet Tab List Item Click Handler
    var onClickCategoriesBottomSheetTabListItem = function(item) {
        setSelectedCategoriesBottomSheetTabItem(item);
        toggleCategoriesBottomSheet(false);
    };
    var checkEnableSubmit = function(e) {
        e.preventDefault();
        if (!token) {
            setShowAuthModal(true);
            return;
        }
        if ((0,RNPlugins/* isWebView */.vp)()) {
            if (!user.isCertified) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_CERTIFICATION_SCREEN */.nn.MOVE_CERTIFICATION_SCREEN, {
                    params: {
                        base: "qna"
                    }
                });
                return false;
            }
        }
        if (question.length <= 4) {
            toast({
                text: "질문을 최소 5자 이상 입력해주세요.",
                direction: "bottom"
            });
            return false;
        }
        if (!selectedCategoriesBottomSheetTabItem) {
            toast({
                text: "카테고리를 선택해주세요.",
                direction: "bottom"
            });
            return false;
        }
        if (policyAgreementBottomSheetViewModel.hasAlreadyAgreedToAll() || policyAgreementBottomSheetViewModel.hasAgreedToMinimum()) {
            requestAiAnswer();
        } else {
            policyAgreementBottomSheetViewModel.openBottomSheet();
        }
    };
    var requestAiAnswer = function() {
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_ai_answer_bottom_sheet",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        onSubmit({
            isAiAnswer: true
        });
    };
    // 질문 submit
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var coordinate, isAiAnswer;
            return (0,tslib_es6.__generator)(this, function(_state) {
                coordinate = param.coordinate, isAiAnswer = param.isAiAnswer;
                pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, {});
                if (!selectedCategoriesBottomSheetTabItem) return [
                    2
                ];
                setIsSubmitLoading(true);
                addQuestionWithAiAnswerMutate({
                    request: {
                        content: question,
                        pregnant: pregnant,
                        categoryId: selectedCategoriesBottomSheetTabItem.value,
                        tagNames: selectedTags,
                        aiAnswerAvailable: isAiAnswer,
                        location: coordinate !== null && coordinate !== void 0 ? coordinate : null
                    }
                }, {
                    onSuccess: onSubmitSuccess,
                    onError: onSubmitError
                });
                return [
                    2
                ];
            });
        });
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickNearDoctorAlertSkip = function() {
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_near_doctor_alert_skip",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        qnaWriteBottomSheetGroup.onChangeBottomSheetType();
        onSubmit({
            isAiAnswer: selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.aiAnswerAvailable
        });
    };
    var onClickAiAnswerDetail = function(questionPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.AI.path */.Z6.QNA.AI.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.AI.appScreenName */.Z6.QNA.AI.appScreenName,
            params: {
                questionPid: questionPid
            }
        });
    };
    (0,react.useEffect)(function() {
        setSelectedTags([]);
    }, [
        selectedCategoriesBottomSheetTabItem
    ]);
    (0,react.useEffect)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            if (question || selectedCategoriesBottomSheetTabItem) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK */.nn.SET_PREVENT_BACK, {
                    preventBack: true
                });
            } else {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK */.nn.SET_PREVENT_BACK, {
                    preventBack: false
                });
            }
        }
    }, [
        question,
        selectedCategoriesBottomSheetTabItem
    ]);
    (0,react.useEffect)(function() {
        if (userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.isBanned) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "서비스 이용 제한",
                    message: "실시간 상담 운영 정책 위반으로 활동이 제한 되었습니다.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            label: "확인",
                            onClick: function() {
                                closeModal();
                                (0,RNPlugins/* historyBack */.$i)();
                            }
                        }, 
                    ]
                }
            });
        }
    }, [
        userProfileData
    ]);
    (0,react.useEffect)(function() {
        if (unCheckedAiAnswer && (unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationRequested */.cx.GenerationRequested || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.Generating */.cx.Generating || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationFailed */.cx.GenerationFailed) && unCheckedAiAnswer.status !== gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed) showModal({
            type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "기존 답변을 먼저 확인해 주세요",
                message: "고민이 해결됐는지 의료진 상담이 필요한지 알려주신 뒤 다음 질문을 작성할 수 있어요.",
                buttons: [
                    {
                        type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "확인",
                        onClick: function() {
                            closeModal();
                            (0,RNPlugins/* historyBack */.$i)();
                        }
                    },
                    {
                        type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                        label: "답변 보기",
                        onClick: function() {
                            closeModal();
                            onClickAiAnswerDetail(unCheckedAiAnswer.questionPid);
                        }
                    }, 
                ]
            }
        });
    }, [
        unCheckedAiAnswer === null || unCheckedAiAnswer === void 0 ? void 0 : unCheckedAiAnswer.aiAnswerStatus
    ]);
    (0,react.useEffect)(function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {});
    }, []);
    return {
        question: question,
        setQuestion: setQuestion,
        onClickCheckPregnant: onClickCheckPregnant,
        pregnant: pregnant,
        selectedCategoriesBottomSheetTabItem: selectedCategoriesBottomSheetTabItem,
        selectedTags: selectedTags,
        setSelectedTags: setSelectedTags,
        showCategoriesBottomSheet: showCategoriesBottomSheet,
        toggleCategoriesBottomSheet: toggleCategoriesBottomSheet,
        isSubmitLoading: isSubmitLoading,
        userProfile: userProfileData,
        onClickCategoriesBottomSheetTabListItem: onClickCategoriesBottomSheetTabListItem,
        categoryGroup: categoryGroup,
        selectedTab: selectedTab,
        onClickCategoriesBottomSheetTab: onClickCategoriesBottomSheetTab,
        getSelectedTabItemList: getSelectedTabItemList,
        onClickNearDoctorAlertSkip: onClickNearDoctorAlertSkip,
        checkEnableSubmit: checkEnableSubmit,
        isSubmitButtonDisabled: isSubmitButtonDisabled,
        qnaWriteBottomSheetGroup: qnaWriteBottomSheetGroup,
        requestAiAnswer: requestAiAnswer,
        policyAgreementBottomSheetViewModel: policyAgreementBottomSheetViewModel
    };
};
/* harmony default export */ var qna_useQnaWriteMobileViewModel = (useQnaWriteMobileViewModel);

;// CONCATENATED MODULE: ./src/pages/content/qna/write/index.tsx
// PageDescription: 실시간 의료 상담 글 작성 페이지










var QnaWrite = function(param) {
    var client = param.client;
    var ref = (0,useAuthModal/* default */.Z)(false, true), setShowAuthModal = ref.setShowAuthModal, setTrackInfo = ref.setTrackInfo;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var qnaWriteMobileViewModel = qna_useQnaWriteMobileViewModel();
    (0,react.useEffect)(function() {
        if (token === null && client.isWebView) {
            return;
        }
        if (!token) {
            setShowAuthModal(true);
            setTrackInfo({
                campaign: "web_content_qna_write",
                content: "web_content_mdl_details",
                buttonText: ""
            });
        }
    }, [
        setShowAuthModal,
        token,
        client
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "실시간 의료상담 - 닥터나우",
                description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                openGraph: {
                    title: "실시간 의료상담 - 닥터나우",
                    description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-qna.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(qna_write_mobile_template, {
                client: client,
                qnaWriteMobileViewModel: qnaWriteMobileViewModel
            })
        ]
    });
};
QnaWrite.Layout = DefaultLayout/* default */.Z;
/* harmony default export */ var write = (QnaWrite);


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ }),

/***/ 96469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ realTimeAnswerState; },
/* harmony export */   "x": function() { return /* binding */ recentKeywordListState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6983);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);



var realTimeAnswerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "realtimeAnswerState",
    default: false,
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("realtime")
    ]
});
var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_1__/* .recoilPersist */ .J)().persistAtom;
var recentKeywordListState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "recentKeywordListState",
    default: [],
    effects_UNSTABLE: [
        persistAtom
    ]
});


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ hooks_useAirbridgeDynamicLink; }
});

// UNUSED EXPORTS: useDebounceWithLoading

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/shared/hooks/useAirbridgeDynamicLink.ts










var AIRBRIDGE_PARAM_PREFIX = "ab_";
var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var formatOptionsForLogging = function(options) {
    return Object.fromEntries(Object.entries(options).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            "".concat(AIRBRIDGE_PARAM_PREFIX).concat(key),
            typeof value === "number" ? value.toString() : value, 
        ];
    }));
};
var useAirbridgeDynamicLink = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "web_organic", initOptions = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var getDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getDynamicLink */.Z.getDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, initOptions, options), linkType);
    };
    var getTrackingParams = function() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getTrackingParams */.Z.getTrackingParams(linkType);
    };
    var createTrackingLinkAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(channel, options) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    airbridge/* default.createTrackingLinkAsync */.Z.createTrackingLinkAsync(channel, options)
                ];
            });
        });
        return function createTrackingLinkAsync(channel, options) {
            return _ref.apply(this, arguments);
        };
    }();
    var logToFirebase = function(eventName, options) {
        var pageName = (0,logger/* getPageName */.j0)(router);
        var sanitizedEventName = sanitizeEventName(eventName);
        var formattedOptions = formatOptionsForLogging((0,_object_spread/* default */.Z)({}, initOptions, options));
        var payload = (0,_object_spread/* default */.Z)({
            page_name: pageName
        }, formattedOptions);
        if (env/* IS_LOCAL */.Kc) {
            console.log("logger >>", (0,_object_spread/* default */.Z)({
                eventName: sanitizedEventName
            }, payload));
            return;
        }
        firebase/* default.logEventOnlyFirebase */.Z.logEventOnlyFirebase(sanitizedEventName, payload);
    };
    var navigateWithTracking = function(eventName, options) {
        var linkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        var customOptions = (0,_object_spread/* default */.Z)({}, initOptions, options);
        logToFirebase(eventName, customOptions);
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, customOptions), linkType);
    };
    return {
        navigateWithTracking: navigateWithTracking,
        getDynamicLink: getDynamicLink,
        getTrackingParams: getTrackingParams,
        logToFirebase: logToFirebase,
        createTrackingLinkAsync: createTrackingLinkAsync
    };
};
/* harmony default export */ var hooks_useAirbridgeDynamicLink = (useAirbridgeDynamicLink);

// EXTERNAL MODULE: ./src/shared/hooks/useDebounceWithLoading.ts
var useDebounceWithLoading = __webpack_require__(78974);
;// CONCATENATED MODULE: ./src/shared/hooks/index.ts





/***/ }),

/***/ 78974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useDebounceWithLoading = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), debounced = ref[0], setDebounced = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(previousValue.current, value)) {
            setIsLoading(true);
            previousValue.current = value;
        }
        var handler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            setDebounced(value);
            setIsLoading(false);
        }, delay, options);
        handler();
        return function() {
            handler.cancel();
        };
    }, [
        value,
        delay,
        options
    ]);
    return {
        debouncedValue: debounced,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounceWithLoading);


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7041,6492,9097,2110,3879,8391,2271,9653,6326,1743,4365,5679,5491,2030,9774,2888,179], function() { return __webpack_exec__(88226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);